"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMembershipType = void 0;
var IMembershipType;
(function (IMembershipType) {
    IMembershipType["Free"] = "free";
    IMembershipType["Premium"] = "premium";
    IMembershipType["CoachPlus"] = "coach-plus";
    IMembershipType["PremiumNonEquipment"] = "premium-non-equipment";
})(IMembershipType || (exports.IMembershipType = IMembershipType = {}));
//# sourceMappingURL=membership-type.js.map